import { useCallback } from 'react';
import { useTrackEvent } from '$analytics/useTrackAnalytics/useTrackAnalytics';
import {
  AppRefreshEventLabels,
  AppRefreshEventsMap,
  type TrackAppRefreshModalEvent,
} from './events';

export function useTrackAppRefreshModalAnalytics() {
  const trackEvent = useTrackEvent();

  return useCallback(
    (event: TrackAppRefreshModalEvent, extra?: Record<string, unknown>) => {
      const eventLabel = AppRefreshEventLabels[event];
      const eventInfo = AppRefreshEventsMap[event];
      trackEvent(eventLabel, {
        ...eventInfo,
        ...extra,
      });
    },
    [trackEvent],
  );
}
